/** How close achieved growth (`planned`) came to the market benchmark (`target`), as a 0-100
 *  score — `0` if there was no growth at all, `100` if growth met or exceeded the benchmark (or
 *  the benchmark itself was zero/negative), otherwise the proportional `planned/target` ratio.
 *  Mirrors `getPoints` in the legacy `financialPlanQuality` feature. */
export const getPlanningQuality = (
  planned: number | null,
  target: number | null
): number | null => {
  if (planned === null || target === null) {
    return null
  }

  if (planned <= 0) {
    return 0
  }

  if (target <= 0 || planned >= target) {
    return 100
  }

  return Math.round((planned / target) * 100)
}
